import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { StatCard, PageHeader } from "@/components/common/DashboardBits";
import { useLang } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";

const BAR_CURSOR = { fill: "#f1f5f9" };
const BAR_RADIUS = [4, 4, 0, 0];
const inr = (v) => `₹ ${Number(v).toLocaleString("en-IN")}`;

export default function AdminOverview() {
  const { t } = useLang();
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [earnings, setEarnings] = useState(null);

  useEffect(() => {
    api.get("/dashboard/stats").then((r) => setStats(r.data)).catch(() => {});
    api.get("/reports/earnings").then((r) => setEarnings(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <PageHeader
        title={`${t("welcome_back")}, ${user?.name || "Admin"}`}
        subtitle="Pan-Rajasthan operations overview"
      />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <StatCard testId="stat-banks" label={t("banks")} value={stats?.banks ?? "—"} tone="blue" />
        <StatCard testId="stat-executives" label={t("executives")} value={stats?.executives ?? "—"} tone="amber" />
        <StatCard testId="stat-staff" label={t("staff")} value={stats?.staff ?? "—"} tone="violet" />
        <StatCard testId="stat-total-leads" label={t("total_leads")} value={stats?.total_leads ?? "—"} />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <StatCard testId="stat-pending" label={t("pending")} value={stats?.pending ?? 0} tone="amber" />
        <StatCard testId="stat-in-progress" label={t("in_progress")} value={stats?.in_progress ?? 0} tone="blue" />
        <StatCard testId="stat-visited" label={t("visited")} value={stats?.visited ?? 0} tone="green" />
        <StatCard testId="stat-submitted" label={t("submitted")} value={stats?.submitted ?? 0} tone="green" />
      </div>

      <Card className="border border-slate-200">
        <CardContent className="p-6">
          <div className="flex items-baseline justify-between mb-4">
            <div>
              <div className="text-xs font-bold uppercase tracking-widest text-slate-500">{t("daily_earnings")}</div>
              <div className="font-heading text-xl font-semibold text-slate-950 mt-1">Last 30 days</div>
            </div>
            <div className="num text-2xl font-bold text-slate-950">
              ₹ {Number(earnings?.grand_total || 0).toLocaleString("en-IN")}
            </div>
          </div>
          <div className="h-60">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={earnings?.daily || []}>
                <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="date" stroke="#94a3b8" fontSize={11} tickFormatter={(d) => d.slice(5)} />
                <YAxis stroke="#94a3b8" fontSize={11} />
                <Tooltip cursor={BAR_CURSOR} formatter={inr} />
                <Bar dataKey="amount" fill="#2563eb" radius={BAR_RADIUS} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
